import React from 'react'
import { CloudinaryContext, Transformation, Image } from 'cloudinary-react'
import axios from 'axios'
import Link from 'gatsby-link'
import '../../node_modules/glightbox/dist/css/glightbox.min.css'
import ScrollableAnchor from 'react-scrollable-anchor'

if (typeof window !== `undefined`) {
    var GLightbox = require('glightbox')
  }

class Gallery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gallery: [],
            galleryName: this.props.galleryName,
            galleryTitle: this.props.galleryTitle,
            galleryDesc: this.props.galleryDesc    
        }
        this.lightBox = this.lightBox.bind(this);
    }
    componentDidMount(){
        axios.get(`https://res.cloudinary.com/zackshave/image/list/${this.state.galleryName}.json`)
            .then(res => {
                console.log(res.data.resources);
                this.setState({gallery: res.data.resources});
            });
    }
    lightBox(e) {
        e.preventDefault();
        if (typeof navigator !== `undefined`) {
        let lightBox = GLightbox({
            selector: `lightbox-${this.state.galleryName}`
        });
    }
    }
    render(){
        return (
                <div className="gallery">
                <ScrollableAnchor id={this.state.galleryName}><h2 className="title is-4">{this.state.galleryTitle}</h2></ScrollableAnchor>
                    <CloudinaryContext cloudName="zackshave" className="columns is-multiline is-mobile is-centered" onLoad={this.lightBox}>
                        {   
                            this.state.gallery.sort(function(a, b){return a - b}).map(data => {
                                return (
                                    <div className="column is-half-mobile is-one-third-tablet" key={data.public_id}>
                                        <div className="img">
                                            <a href={`https://res.cloudinary.com/zackshave/image/upload/v1/${data.public_id}.jpg`} className={`lightbox-${this.state.galleryName}`} data-title={data.context.custom.caption} data-description={data.context.custom.alt}>
                                                <Image publicId={data.public_id}>
                                                <Transformation
                                                        crop="scale"
                                                        height="725"
                                                        width="725"
                                                        crop="lpad"
                                                        dpr="auto"
                                                        responsive_placeholder="blank"
                                                    />
                                                </Image>
                                            </a>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </CloudinaryContext>
                    <p>
                    {this.state.galleryDesc}
                    {(this.state.galleryName === 'gallery-1') ? <small className="giclee mt-1">* The images in this gallery are available on giclee, an archival inkjet print with pigment inks. You can <Link to="/contact" className="giclee-link">contact me</Link> for more details.</small> : ''}
                    </p>
                </div>
        );
    }
}

export default Gallery


// WEBPACK FOOTER //
// ./src/components/Gallery.js